import { render, staticRenderFns } from "./OttawaLab2ReportTask6Data.vue?vue&type=template&id=47bb4e26&"
import script from "./OttawaLab2ReportTask6Data.vue?vue&type=script&lang=js&"
export * from "./OttawaLab2ReportTask6Data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VForm,VSelect,VSimpleTable,VTextarea})
